import { Pipe, PipeTransform } from '@angular/core';

/**
 * Obsahuje seznam akcí řádku (`akce` z BE) danou akci? Např. `row.akce | hasAkce: AkceSablonyE.Detail`.
 */
@Pipe({
  name: 'hasAkce',
})
export class HasAkcePipe implements PipeTransform {
  transform<T>(akce: readonly T[] | null | undefined, hledana: T): boolean {
    return !!akce?.includes(hledana);
  }
}
